<template>
    <sui-card fluid>
        <sui-card-content style="display: flex; align-items: center;">
            <sui-icon name="bullseye violet icon" style="margin-right: 14px"></sui-icon>
            <h3 style="margin: 0;" is="sui-header">{{ $t('gateway.metadatas.listTitle') }}</h3>
        </sui-card-content>

        <sui-card-content>
            <sui-list>
                <sui-list-item v-for="metadata in metadatas" :key="metadata.id">
                    <div class="content">
                        <sui-popup :content="metadata.description">
                            <sui-button
                            slot="trigger"
                            :class="metadata.color"
                            class="ui fluid button"
                            @click="onClick(metadata.id)"
                        >{{ metadata.label }}</sui-button>
                        </sui-popup>
                    </div>
                </sui-list-item>
            </sui-list>
        </sui-card-content>
    </sui-card>
</template>

<script>
    import store from '@/store';

    export default {
        name: 'MetadataList',
        methods: {
            replaceBetween(start, end, subject, replaceWith) {
                return subject.substring(0, start) + replaceWith + subject.substring(end);
            },
            onClick(id) {
                if (!this.state.forms.gateway.currentSelectedInput) {
                    return;
                }

                this.state.forms.gateway.currentSelectedInput.value = this.replaceBetween(
                    this.state.forms.gateway.currentSelectedInput.selectionStart,
                    this.state.forms.gateway.currentSelectedInput.selectionEnd,
                    this.state.forms.gateway.currentSelectedInput.value,
                    this.state.metadatas.find(m => m.id === id).code,
                );

                this.state.forms.gateway.currentSelectedInput.focus();
                this.state.forms.gateway.currentSelectedInput.dispatchEvent(new Event('input'));
            },
        },
        computed: {
            state: {
                get() { return store.state; }
            },
            metadatas: {
                get() { return this.state.metadatas.filter(m => m.isSelectable); }
            }
        },
    }
</script>
